import { useEffect, useRef } from "react";

const CloudinaryUploadWidget = ({ uwConfig, setPublicId, setUploading }) => {
  const widgetRef = useRef();

  useEffect(() => {
    if (!window.cloudinary) {
      const script = document.createElement("script");
      script.src = "https://widget.cloudinary.com/v2.0/global/all.js";
      script.async = true;
      script.onload = () => {
        widgetRef.current = window.cloudinary.createUploadWidget(
          uwConfig,
          (error, result) => {
            if (result && result.event === "queues-start") {
              setUploading(true);
            }
            if (
              result &&
              (result.event === "success" ||
                result.event === "close" ||
                result.event === "queues-end")
            ) {
              setUploading(false);
            }
            if (!error && result && result.event === "success") {
              setPublicId(result.info.public_id);
            }
          }
        );
      };
      document.body.appendChild(script);
    } else {
      widgetRef.current = window.cloudinary.createUploadWidget(
        uwConfig,
        (error, result) => {
          if (result && result.event === "queues-start") {
            setUploading(true);
          }
          if (
            result &&
            (result.event === "success" ||
              result.event === "close" ||
              result.event === "queues-end")
          ) {
            setUploading(false);
          }
          if (!error && result && result.event === "success") {
            setPublicId(result.info.public_id);
          }
        }
      );
    }
  }, [uwConfig, setPublicId, setUploading]);

  return (
    <button
      type="button"
      className="btn btn-primary"
      onClick={() => widgetRef.current && widgetRef.current.open()}
    >
      Upload Image
    </button>
  );
};

export default CloudinaryUploadWidget;
